import React from "react";
import * as SelectPaneStyles from "../../../../../common-deprecated/styles/v2/toyota/custom/SelectPane";
import * as Type from "../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { useCompareV2Selector } from "../../../redux/store";
import { isModelCodeNewGeneration } from "../../../utils/utils";
import Icon from "../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { useCompareV2OptionalLabel, CompareV2Label } from "../../../utils/labels";
import { isRTL } from "../../../../../common-deprecated/settings/utils/commonSettingUtils";
import type { ModelGradeBodyTypeIdsType } from "../../../../../common-deprecated/features/compare/utils/newCarCompareTypes";
import { NcCompareContext } from "../../../../../common-deprecated/types/NewCarCompareTypes";

type ModelPanelPropsType = {
    setModel: (modelCode: string) => void;
    selectedCar: ModelGradeBodyTypeIdsType | null;
};

const ModelPanel = (props: ModelPanelPropsType): JSX.Element => {
    const { setModel, selectedCar } = props;
    const availableCarsData = useCompareV2Selector((state) => {
        const { filteredCarList, available } = state.newCarCompare;
        if (state.newCarCompare.ncCompareContext === NcCompareContext.Leasing && filteredCarList?.length > 0) {
            // Filter out all models that don't have an available (leasing)configuration
            const availableCongifurationIds = filteredCarList.map((filteredCar) => filteredCar.configurationId);
            return available.filter((car) =>
                car.subModels?.some((submodel) =>
                    submodel.grades?.some((grade) =>
                        grade.bodyTypes?.some((bodyType) =>
                            bodyType.configurations?.some((configuration) =>
                                availableCongifurationIds.includes(configuration.id),
                            ),
                        ),
                    ),
                ),
            );
        }
        return available;
    });
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);
    const selectGradeLabel = useCompareV2OptionalLabel("compareSelectGradeNextGen");

    return (
        <SelectPaneStyles.Panel>
            <SelectPaneStyles.PanelScroll>
                {availableCarsData.map((model) => {
                    return (
                        <SelectPaneStyles.PanelItem
                            key={model.modelCode}
                            onClick={() => setModel(model.modelCode)}
                            id={`${model.modelCode}-header`}
                            aria-expanded={selectedCar?.model === model.modelCode}
                            aria-controls={`${model.modelCode}-pane`}
                            tabIndex={selectedCar?.model ? -1 : 0}
                        >
                            <Type.Text headingType="sub-epsilon" mb={0}>
                                {isModelCodeNewGeneration(commonSettings, model.modelCode) && selectGradeLabel ? (
                                    <CompareV2Label
                                        label="compareSelectGradeNextGen"
                                        params={{ model: model.modelName }}
                                    />
                                ) : (
                                    model.modelName
                                )}
                            </Type.Text>
                            <IconWrapper iconColor="primaryBlack">
                                <Icon variant={isRTL(commonSettings) ? "chevronLeft" : "chevronRight"} />
                            </IconWrapper>
                        </SelectPaneStyles.PanelItem>
                    );
                })}
            </SelectPaneStyles.PanelScroll>
        </SelectPaneStyles.Panel>
    );
};

export default ModelPanel;
